module.exports = __webpack_public_path__ + "static/media/apple.ff0778f1.png";